// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1aQSh","detailsBorder":"styles_detailsBorder__3F2M0"};